import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';

const Breadcrumb: React.FC = () => {
    const location = useLocation();
    const pathnames = useMemo(() => location.pathname.split('/').filter(x => x), [location]);

    return (
        <div className="text-sm breadcrumbs">
            <ul>
                <li><Link to="/">Home</Link></li> 
                {pathnames.map((value, index) => {
                    const to = `/${pathnames.slice(0, index + 1).join('/')}`;
                    const isLast = index === pathnames.length - 1;

                    return isLast ? (
                        <li key={to}>{value}</li>
                    ) : (
                        <li key={to}><Link to={to}>{value}</Link></li>
                    );
                })}
            </ul>
        </div>
    );
}

export default Breadcrumb;
